import { useGlobalContext } from "../Context/GlobalContext";

export const Logo = () => {
    const { getThemeImage } = useGlobalContext();
    return <div className="landing-logo">
        <img src={getThemeImage("Knog")} alt="knog" />
    </div>
}